import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { DatePickerModule } from 'primeng/datepicker';
import { MessageModule } from 'primeng/message';

@Component({
  selector: 'app-date-input',
  imports: [ReactiveFormsModule, DatePickerModule, MessageModule],
  templateUrl: './date-input.component.html',
  styleUrl: './date-input.component.scss'
})
export class DateInputComponent {

    @Input() form!: FormGroup;
    @Input() field!: string;
    @Input() label!: string;
    @Input() placeholder!: string;

}
